import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/**
 * A component that displays a loading spinner with a circle and rectangle.
 */
class E11LoaderSpinnerComponent {
    constructor() {
        /**
         * The color of the spinner.
         * This can be a color class or a hex value.
         * @type {string}
         * @default 'e11-border-skin-primary-accent'
         */
        this.color = 'e11-border-skin-primary-accent';
        /**
         * The size of the spinner.
         * This can be 'xs', 'sm', 'md', 'lg', or 'xl'.
         * @type {string}
         * @default 'md'
         */
        this.size = 'md';
        /**
         * The font size of the label.
         * This can be a string with a px or rem value.
         * @type {string}
         * @default '1rem'
         */
        this.fontSize = '1rem';
        /**
         * The label to display below the spinner.
         * @type {string}
         * @default 'Loading...'
         */
        this.label = 'Loading...';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11LoaderSpinnerComponent, isStandalone: true, selector: "e11-loader-spinner", inputs: { color: "color", size: "size", fontSize: "fontSize", label: "label" }, ngImport: i0, template: `
    <div
      class="circle-container e11-bg-white e11-relative e11-mx-auto e11-flex e11-items-center e11-justify-center e11-rounded-full e11-border e11-border-dashed e11-border-gray-300 e11-z-[1]"
      [ngClass]="{
        'e11-h-12 e11-w-12': size === 'xs',
        'e11-h-24 e11-w-24': size === 'sm',
        'e11-h-36 e11-w-36': size === 'md',
        'e11-h-48 e11-w-48': size === 'lg',
        'e11-h-56 e11-w-56': size === 'xl'
      }"
    >
      <div
        class="circle e11-relative e11-mx-auto e11-flex e11-items-center e11-justify-center e11-rounded-full e11-border-2 e11-border-solid e11-z-[1] {{
          color
        }}"
        [ngClass]="{
          'e11-h-8 e11-w-8': size === 'xs',
          'e11-h-16 e11-w-16': size === 'sm',
          'e11-h-28 e11-w-28': size === 'md',
          'e11-h-36 e11-w-36': size === 'lg',
          'e11-h-44 e11-w-44': size === 'xl'
        }"
      >
        <div class="e11-text-base e11-absolute e11-z-[2]" style="font-size: {{ fontSize }};">{{ label }}</div>
        <div
          class="rectangle e11-bg-white e11-absolute e11-z-[1]"
          [ngClass]="{
            'e11-h-4 e11-w-10': size === 'xs',
            'e11-h-8 e11-w-20': size === 'sm',
            'e11-h-12 e11-w-32': size === 'md',
            'e11-h-20 e11-w-40': size === 'lg',
            'e11-h-32 e11-w-44': size === 'xl'
          }"
        ></div>
      </div>
    </div>
  `, isInline: true, styles: [".rectangle{animation:spin 2s cubic-bezier(.26,1.36,.74,-.29) infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-loader-spinner', standalone: true, imports: [CommonModule], template: `
    <div
      class="circle-container e11-bg-white e11-relative e11-mx-auto e11-flex e11-items-center e11-justify-center e11-rounded-full e11-border e11-border-dashed e11-border-gray-300 e11-z-[1]"
      [ngClass]="{
        'e11-h-12 e11-w-12': size === 'xs',
        'e11-h-24 e11-w-24': size === 'sm',
        'e11-h-36 e11-w-36': size === 'md',
        'e11-h-48 e11-w-48': size === 'lg',
        'e11-h-56 e11-w-56': size === 'xl'
      }"
    >
      <div
        class="circle e11-relative e11-mx-auto e11-flex e11-items-center e11-justify-center e11-rounded-full e11-border-2 e11-border-solid e11-z-[1] {{
          color
        }}"
        [ngClass]="{
          'e11-h-8 e11-w-8': size === 'xs',
          'e11-h-16 e11-w-16': size === 'sm',
          'e11-h-28 e11-w-28': size === 'md',
          'e11-h-36 e11-w-36': size === 'lg',
          'e11-h-44 e11-w-44': size === 'xl'
        }"
      >
        <div class="e11-text-base e11-absolute e11-z-[2]" style="font-size: {{ fontSize }};">{{ label }}</div>
        <div
          class="rectangle e11-bg-white e11-absolute e11-z-[1]"
          [ngClass]="{
            'e11-h-4 e11-w-10': size === 'xs',
            'e11-h-8 e11-w-20': size === 'sm',
            'e11-h-12 e11-w-32': size === 'md',
            'e11-h-20 e11-w-40': size === 'lg',
            'e11-h-32 e11-w-44': size === 'xl'
          }"
        ></div>
      </div>
    </div>
  `, styles: [".rectangle{animation:spin 2s cubic-bezier(.26,1.36,.74,-.29) infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { color: [{
                type: Input
            }], size: [{
                type: Input
            }], fontSize: [{
                type: Input
            }], label: [{
                type: Input
            }] } });

class E11LoaderSpinnerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderSpinnerModule, imports: [E11LoaderSpinnerComponent], exports: [E11LoaderSpinnerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderSpinnerModule, imports: [E11LoaderSpinnerComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [E11LoaderSpinnerComponent],
                    exports: [E11LoaderSpinnerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11LoaderSpinnerComponent, E11LoaderSpinnerModule };
